module.exports = __webpack_public_path__ + "static/img/14.7a0c70b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/14.jpg
// module id = 2Alh
// module chunks = 16